import { FileFormatTypes } from 'common/enums';

export const getFileExtension = (filePath: string) => {
  const extensionArr = filePath.split('.');
  return extensionArr[extensionArr.length - 1] as FileFormatTypes;
};
